<template>
	<div class="mall-shop-page">
		<shop-workbench-nav active-key="my" />
		<div class="shop-panel" v-loading="loading">
			<div class="page-header">
				<div>
					<h3 class="page-title">闭店申请</h3>
					<div class="page-sub">提交闭店申请后，需等待平台审核通过后店铺才会关闭。</div>
				</div>
				<el-button @click="$router.push('/mall/shop/my')">返回我的店铺</el-button>
			</div>

			<div class="close-warning">
				闭店审核通过后，店铺将变为已闭店状态，不能继续提交资料变更。请确认当前订单、服务和售后事项已处理完毕。
			</div>

			<el-form ref="closeFormRef" :model="formData" :rules="formRules" label-position="top">
				<div class="section">
					<div class="section-title">店铺信息</div>
					<div class="info-grid">
						<div class="info-item">
							<span class="info-label">店铺名称：</span>
							<span class="info-value">{{ shopInfo.shopName || '-' }}</span>
						</div>
						<div class="info-item">
							<span class="info-label">经营状态：</span>
							<span class="info-value">{{ shopStateText }}</span>
						</div>
					</div>
				</div>

				<div class="section">
					<div class="section-title">闭店原因</div>
					<el-form-item prop="closeReason">
						<el-input
							v-model="formData.closeReason"
							type="textarea"
							:rows="5"
							maxlength="300"
							show-word-limit
							resize="none"
							placeholder="请输入闭店原因"
						/>
					</el-form-item>
				</div>

				<div class="form-actions">
					<el-button @click="$router.push('/mall/shop/my')">取消</el-button>
					<el-button type="danger" :loading="submitLoading" @click="handleSubmit">提交闭店申请</el-button>
				</div>
			</el-form>
		</div>
	</div>
</template>

<script>
	import ShopWorkbenchNav from './components/WorkbenchNav.vue'
	import { closeSubmitMerchantShopApply, queryMyLatestShopApply, queryMyShop } from '@/api/mall'
	import { getUuid } from '@/utils'
	import { ENUM_SHOP_STATE, SHOP_AUDIT_STATE, SHOP_APPLY_TYPE, SHOP_STATE } from '@/enum/index.js'

	export default {
		name: 'MallShopClose',
		components: { ShopWorkbenchNav },
		data() {
			return {
				loading: false,
				submitLoading: false,
				shopInfo: {},
				formData: {
					id: getUuid(),
					closeReason: ''
				},
				formRules: {
					closeReason: [{ required: true, message: '请输入闭店原因', trigger: 'blur' }]
				}
			}
		},
		computed: {
			shopStateText() {
				return ENUM_SHOP_STATE[this.shopInfo.shopState] || '-'
			}
		},
		created() {
			this.initPage()
		},
		methods: {
			async initPage() {
				this.loading = true
				try {
					const shopRes = await queryMyShop()
					this.shopInfo = shopRes.data || {}
					if (!this.shopInfo.id || Number(this.shopInfo.shopState) !== SHOP_STATE.NORMAL) {
						this.$message.warning('只有正常经营的店铺才能提交闭店申请')
						this.$router.replace('/mall/shop/my')
						return
					}
					const latestRes = await queryMyLatestShopApply().catch(() => ({ data: null }))
					const latestApply = latestRes.data || null
					if (latestApply && Number(latestApply.auditState) === SHOP_AUDIT_STATE.PENDING) {
						this.$message.warning('已有待审核申请，请等待平台审核')
						this.$router.replace({ path: '/mall/shop/apply-detail', query: { id: latestApply.id } })
					}
				} finally {
					this.loading = false
				}
			},
			handleSubmit() {
				this.$refs.closeFormRef.validate(async valid => {
					if (!valid) return
					this.submitLoading = true
					try {
						await closeSubmitMerchantShopApply({
							id: this.formData.id,
							shopId: this.shopInfo.id,
							applyType: SHOP_APPLY_TYPE.CLOSE,
							closeReason: this.formData.closeReason,
							remark: this.formData.closeReason
						})
						this.$message.success('闭店申请已提交，请等待平台审核')
						this.$router.push({ path: '/mall/shop/apply-detail', query: { id: this.formData.id } })
					} finally {
						this.submitLoading = false
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import './shop.scss';
</style>
